import logo from "./logo.svg";
import "./App.css";
import Navbar from "./custom/Navbar";
import Homepage from "./components/Homepage";
import ContactUs from "./components/ContactUs";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Blog from "./components/Blog";
import Projects from "./components/Projects";
import AboutUs from "./components/AboutUs";
import Footer from "./custom/Footer";
import My_Projects from "./components/My_Projects";
import React, { useEffect, useState } from "react";
import MobNavbar from "./custom/MobNavbar";

function App() {
  const pagewidth = window.innerWidth;
  const pageheight = window.innerHeight;
  const [selected, setSelected] = useState("h");

  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const aboutDist = (95 * pageheight) / 100;

  function HomeScroll() {
    window.scrollTo(0, 0);
  }
  function AboutMeScroll() {
    window.scrollTo(0, aboutDist - 20);
  }

  function ProjectsScroll() {
    const ele = document.querySelector("#aboutMe");
    const projectDist = ele.clientHeight + aboutDist;
    window.scrollTo(0, projectDist);
  }

  function ContactScroll() {
    const ele1 = document.querySelector("#aboutMe");
    const projectDist1 = ele1.clientHeight + aboutDist;

    const ele2 = document.querySelector("#Projects");
    const contactDist = ele2.clientHeight + projectDist1;
    window.scrollTo(0, contactDist - 20);
  }

  useEffect(() => {
    let scroll = document.documentElement.scrollTop || document.body.scrollTop;
    const ele = document.querySelector("#aboutMe");
    const projectDist = ele.clientHeight + aboutDist;

    const ele2 = document.querySelector("#Projects");
    const contactDist = ele2.clientHeight + projectDist;

    console.log("orig ", scroll, " new we want ", aboutDist - 20)

    if (scroll >= 0 && scroll < Math.floor(aboutDist - 20)) {
      setSelected("h");
    } else if (scroll >= Math.floor(aboutDist - 20) && scroll < Math.floor(projectDist - 20)) {
      setSelected("a");
    }
    else if(scroll>=Math.floor(projectDist - 20) && scroll<Math.floor(contactDist - 20)){
        setSelected("p");
    }
    else if(scroll>=Math.floor(contactDist - 20)){
        setSelected("c");
    }
  }, [document.documentElement.scrollTop || document.body.scrollTop]);

  console.log(
    "curent scroll",
    document.documentElement.scrollTop || document.body.scrollTop
  );
  //   useEffect(() => {
  //     // ProjectsScroll();
  //     ContactScroll();
  //   }, []);

  console.log(scrollPosition);
  const [small, setsmall] = useState(false);
  useEffect(() => {
    if (pagewidth <= 960) {
      setsmall(true);
    } else if (pagewidth > 960) {
      setsmall(false);
    }
  }, small);

  const [darkMode, setDarkMode] = useState(true);

  return (
    <div
      style={{ backgroundColor: darkMode ? "rgb(17 24 39)" : "darkcyan" }}
      className="App"
    >
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <>
                {small ? (
                  <MobNavbar darkMode={darkMode} setDarkMode={setDarkMode} />
                ) : (
                  <Navbar
                    ContactScroll={ContactScroll}
                    AboutMeScroll={AboutMeScroll}
                    ProjectsScroll={ProjectsScroll}
                    HomeScroll={HomeScroll}
                    darkMode={darkMode}
                    selected={selected}
                    setSelected={setSelected}
                    setDarkMode={setDarkMode}
                  />
                )}
                <Homepage darkMode={darkMode} />
                <AboutUs darkMode={darkMode} />
                <Projects darkMode={darkMode} />
                <ContactUs darkMode={darkMode} />
                <Footer darkMode={darkMode} />
              </>
            }
          />
          {/*<Route*/}
          {/*    path="/ContactUs"*/}
          {/*    element={*/}
          {/*        <>*/}
          {/*            <ContactUs/> <Footer/>*/}
          {/*        </>*/}
          {/*    }*/}
          {/*/>*/}
          {/*<Route*/}
          {/*    path="/blog"*/}
          {/*    element={*/}
          {/*        <>*/}
          {/*            <Blog/>*/}
          {/*        </>*/}
          {/*    }*/}
          {/*/>*/}
          {/*<Route*/}
          {/*    path="/projects"*/}
          {/*    element={*/}
          {/*        <>*/}
          {/*            /!* <My_Projects /> *!/*/}
          {/*            <Projects/> <Footer/>*/}
          {/*        </>*/}
          {/*    }*/}
          {/*/>*/}
          {/*<Route*/}
          {/*    path="/aboutus"*/}
          {/*    element={*/}
          {/*        <>*/}
          {/*            <AboutUs/> <Footer/>*/}
          {/*        </>*/}
          {/*    }*/}
          {/*/>*/}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
